import { render, staticRenderFns } from "./_Templates.vue?vue&type=template&id=6be215cc&"
import script from "./_Templates.vue?vue&type=script&lang=ts&"
export * from "./_Templates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports